import { render, staticRenderFns } from "./mbRouteView.vue?vue&type=template&id=00a2886f&scoped=true&"
import script from "./mbRouteView.vue?vue&type=script&lang=js&"
export * from "./mbRouteView.vue?vue&type=script&lang=js&"
import style0 from "./mbRouteView.vue?vue&type=style&index=0&id=00a2886f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a2886f",
  null
  
)

export default component.exports